export const PROXY_IMAGE_ROUTE = '/player/proxy/upload_cover_diploma';
export const PROXY_IMAGE = 'PROXY_IMAGE';
export const PROXY_IMAGE_SUCCESS = 'PROXY_IMAGE_SUCCESS';